if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        // this.addWishlistBtn = this.querySelector("#addWishlist");
        // this.addWishlistBtn.addEventListener('click', this.addWishlistHandler.bind(this));

        // this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';


        this.wishlist = window.GLOBAL?.wishlist;
        this.wishlistItem = null;

        this.wishlistBtn = this.querySelector("#addWishlist");

        if(this.wishlistBtn){
          this.heartFill = this.wishlistBtn.querySelector(".heart-fill");
          this.heartLineFill = this.wishlistBtn.querySelector(".heart-line");
          this.wishlistBtn.addEventListener(
              "click",
              this.addToWishlistClickHandler.bind(this)
          );
        }

        window.GLOBAL.wishlist && this.handleWishlistLoaded({ detail: window.GLOBAL.wishlist });
        window.document.addEventListener('wishlistLoaded', this.handleWishlistLoaded.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }


      async addWishlistHandler(){

        const variantId = this.dataset.variantId;
        const customerId = window.GLOBAL.customerId;
        const productId = this.dataset.id;
        const handle = this.dataset.handle;
        const wishListItemId = this.wishlistItem?.WishListItemID;
        const qty = 1;

        await addToWishlist({
            customerId,
            productId,
            handle,
            variantId,
            qty,
        });
      }


      async addToWishlistClickHandler(event) {
        event.preventDefault();

        const variantId = this.dataset.variantId;
        const customerId = window.GLOBAL.customerId;
        const productId = this.dataset.id;
        const handle = this.dataset.handle;
        const wishListItemId = this.wishlistItem?.WishListItemID;
        const qty = 1;

        if (!customerId) {
            return window.location.replace(window.GLOBAL.routes.account_login_url);
        }

        try {
            if (!wishListItemId) {
                await addToWishlist({
                    customerId,
                    productId,
                    handle,
                    variantId,
                    qty,
                });

                // const productData = JSON.parse(
                //     decodeURIComponent(this.dataset.datalayerProduct)
                // );
                // const productIndex = this.dataset.index;
                // productData.index = productIndex || 0;
                // productData.item_list_id = handleize(this.dataset.placement);
                // productData.item_list_name = this.dataset.placement;

                // pushAddToWishlist(productData);
            } else {
                await removeFromWishlist({
                    customerId,
                    wishListItemId,
                });
            }
            await this.refreshWishlist();
        } catch (error) {
            console.error(error);
        }
      }

      handleWishlistLoaded({ detail }) {
        this.wishlist = detail.data
        this.wishlistItem = this.findWishlistItem()
        this.updateHeartFill()
      }

      async refreshWishlist() {
          window.GLOBAL.wishlist = await getWishlist()
          const event = new window.CustomEvent('wishlistLoaded', { detail: window.GLOBAL.wishlist })
          window.document.dispatchEvent(event)
      }

      findWishlistItem() {
          if (!this.wishlist) {
              return
          }

          const productId = this.dataset.id
          return this.wishlist.find(({ ProductID }) => ProductID === productId)
      }

      updateHeartFill() {
          if (!this.heartFill || !this.wishlist) {
              return
          }

          if (!this.wishlistItem) {
              this.heartFill.style.fill = '';
              this.heartFill.classList.remove('heart-filled')
              return
          }

          this.heartFill.style.fill = 'rgba(230, 93, 28, 1)';
          this.heartLineFill.style.fill = 'rgba(230, 93, 28, 1)';
          this.heartFill.classList.add('heart-filled')

      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

class Wishlist extends HTMLElement {
  constructor() {
      super();
      this.wishlist = window.GLOBAL?.wishlist;
      this.wishlistItem = null;

      this.wishlistBtn = this.querySelector("#addWishlist");

      if(this.wishlistBtn){
        this.heartFill = this.wishlistBtn.querySelector(".heart-fill");
        this.heartLineFill = this.wishlistBtn.querySelector(".heart-line");
        this.wishlistBtn.addEventListener(
            "click",
            this.addToWishlistClickHandler.bind(this)
        );
      }

      window.GLOBAL.wishlist && this.handleWishlistLoaded({ detail: window.GLOBAL.wishlist });
      window.document.addEventListener('wishlistLoaded', this.handleWishlistLoaded.bind(this));
  }

  async addWishlistHandler(){

    const productFormElement = document.querySelector('product-form');
    const variantId = productFormElement.dataset.variantId;
    const customerId = window.GLOBAL.customerId;
    const productId = productFormElement.dataset.id;
    const handle = productFormElement.dataset.handle;
    const wishListItemId = this.wishlistItem?.WishListItemID;
    const qty = 1;

    await addToWishlist({
        customerId,
        productId,
        handle,
        variantId,
        qty,
    });
  }


  async addToWishlistClickHandler(event) {
    event.preventDefault();

    const productFormElement = document.querySelector('product-form');
    const variantId = productFormElement.dataset.variantId;
    const customerId = window.GLOBAL.customerId;
    const productId = productFormElement.dataset.id;
    const handle = productFormElement.dataset.handle;
    const wishListItemId = this.wishlistItem?.WishListItemID;
    const qty = 1;

    if (!customerId) {
        return window.location.replace(window.GLOBAL.routes.account_login_url);
    }

    try {
        if (!wishListItemId) {
            await addToWishlist({
                customerId,
                productId,
                handle,
                variantId,
                qty,
            });

            // const productData = JSON.parse(
            //     decodeURIComponent(this.dataset.datalayerProduct)
            // );
            // const productIndex = this.dataset.index;
            // productData.index = productIndex || 0;
            // productData.item_list_id = handleize(this.dataset.placement);
            // productData.item_list_name = this.dataset.placement;

            // pushAddToWishlist(productData);
        } else {
            await removeFromWishlist({
                customerId,
                wishListItemId,
            });
        }
        await this.refreshWishlist();
    } catch (error) {
        console.error(error);
    }
  }

  handleWishlistLoaded({ detail }) {
      this.wishlist = detail.data
      this.wishlistItem = this.findWishlistItem()
      this.updateHeartFill()
  }

  async refreshWishlist() {
      window.GLOBAL.wishlist = await getWishlist()
      const event = new window.CustomEvent('wishlistLoaded', { detail: window.GLOBAL.wishlist })
      window.document.dispatchEvent(event)
  }

  findWishlistItem() {
      if (!this.wishlist) {
          return
      }

      const productFormElement = document.querySelector('product-form');
      const productId = productFormElement.dataset.id;
      return this.wishlist.find(({ ProductID }) => ProductID === productId)
  }

  updateHeartFill() {
      if (!this.heartFill || !this.wishlist) {
          return
      }

      if (!this.wishlistItem) {
          this.heartFill.style.fill = ''
          this.heartFill.classList.remove('heart-filled');
          return
      }

      this.heartFill.style.fill = 'rgba(230, 93, 28, 1)';
      this.heartLineFill.style.fill = 'rgba(230, 93, 28, 1)';
      this.heartFill.classList.add('heart-filled');

  }
}

customElements.define("wish-list", Wishlist);
